import React from 'react';

import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import { WeekTraversalHeader } from 'coaching/components/CoachingHomeView/BookOneOffSession';

export type Props = {
  onWeekForward: () => void;
  onWeekBack: () => void;
  weekOffset: number;
  maxOffset?: number;
  startDateTime: string;
  endDateTime: string;
};

export default function CoachingScheduleDateHeader(props: Props) {
  const { onWeekForward, onWeekBack, weekOffset, maxOffset, startDateTime, endDateTime } = props;
  return (
    <React.Fragment>
      <Row>
        <MediaObject inline figure="left">
          <Text data-test="coaching-schedule-heading" weight="normal" size="small">
            Your sessions for
          </Text>
          <WeekTraversalHeader
            data-test="coaching-schedule-week-selector"
            size="xxxxsmall"
            timeRangeTextSize="small"
            buttonSize="small"
            onWeekForward={onWeekForward}
            onWeekBack={onWeekBack}
            weekOffset={weekOffset}
            maxOffset={maxOffset}
            startDateTimeRange={startDateTime}
            endDateTimeRange={endDateTime}
          />
        </MediaObject>
      </Row>
    </React.Fragment>
  );
}
